import {
  useIsMobile,
  WSElement,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { Redirect, Route, Switch } from "react-router-dom";

import { Tabs } from "../../../../components/Tabs";
import { FilterSelectYear } from "../../components/FilterSelectYear";
import { RouteImportContractors } from "../RouteImportContractors";
import { RouteImportPayables } from "../RouteImportPayables";
import styles from "./styles.module.scss";

import { useAccountAccess } from "../../../../v3/hooks/useAccountAccess";
import { useUrlQueryFilters } from "../../../../utils/router";
import { ImportBatchesFilters } from "../../types";
import {
  PATH_IMPORT_CONTRACTORS,
  PATH_IMPORT_PAYABLES,
  routeHelpersImportContractorsStart,
  routeHelpersImportPayablesStart
} from "../../paths";

export function BulkImports() {
  const isMobile = useIsMobile();
  const { hasScope } = useAccountAccess();
  const { filters } = useUrlQueryFilters<ImportBatchesFilters>({});

  const goToContractorImportStart =
    routeHelpersImportContractorsStart.useGoTo();
  const goToPayablesImportStart = routeHelpersImportPayablesStart.useGoTo();

  return (
    <WSPage>
      <WSPageToolbar
        title="Bulk imports"
        titleAfter={<FilterSelectYear defaultYear={Number(filters.year)} />}
        actions={[
          {
            hidden: !hasScope("payments.payable"),
            name: "importPayables",
            buttonKind: "Primary",
            label: "Import payables & deductions",
            onClick: () => {
              goToPayablesImportStart();
            }
          },
          {
            hidden: !hasScope("payments.payee"),
            name: "importContractors",
            label: "Import contractors",
            buttonKind: "Secondary",
            onClick: () => {
              goToContractorImportStart();
            }
          }
        ]}
      />

      <Tabs
        tabs={[
          ...(hasScope("payments.payable")
            ? [
                {
                  path: PATH_IMPORT_PAYABLES,
                  label: "Payables & deductions",
                  params: { year: filters.year }
                }
              ]
            : []),
          ...(hasScope("payments.payee")
            ? [
                {
                  path: PATH_IMPORT_CONTRACTORS,
                  label: "Contractors",
                  params: { year: filters.year }
                }
              ]
            : [])
        ]}
      />
      <WSElement mt={isMobile ? "XL" : "L"} className={styles.wrapper}>
        <Switch>
          {hasScope("payments.payable") ? (
            <Route
              path={PATH_IMPORT_PAYABLES}
              component={RouteImportPayables}
            />
          ) : null}
          {hasScope("payments.payee") ? (
            <Route
              path={PATH_IMPORT_CONTRACTORS}
              component={RouteImportContractors}
            />
          ) : null}
          <Redirect
            from="*"
            to={`${PATH_IMPORT_PAYABLES}?year=${new Date().getFullYear()}`}
          />
        </Switch>
      </WSElement>
    </WSPage>
  );
}
